<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Layanan Kami</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create New Layanan Kami</b>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label mb-n1"
            class="required"
            label="Icon"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>{{icon.name || 'Name'}}</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(56px x 56px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="icon"
                    name="icon"
                    v-validate="'image|minimalDimensions:56,56|size:2000|ext:jpg,png,gif,jpeg,svg'"
                    style="display: none"
                    v-on:change="onChangeicon()"
                  />
                  <b-button
                    @click="$refs.icon.click()"
                    v-show="!icon && !items.icon"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="icon || items.icon"
                    variant="primary"
                    @click="modalIcon = !modalIcon"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.icon.click()"
                    v-show="icon || items.icon"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('icon') }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Image URL WebP"
            label-for="input-1"
          >
            <!-- <input
              v-validate="'required'"
              v-model="items.image_webp"
              name="title_id"
              data-vv-as="Image URL WebP"
              id="input-1"
              class="form-control"
              placeholder="Image URL WebP"
            /> -->
            <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(580px x 380px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="image_webp"
                    name="image_webp"
                    data-vv-as="Image WebP"
                    v-validate="'minimalDimensions:580,380|size:2000|ext:webp'"
                    style="display: none"
                    v-on:change="onChangeImageWebp()"
                  />
                  <b-button
                    @click="$refs.image_webp.click()"
                    v-show="!items.image_webp && !image_webp"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_webp || image_webp"
                    variant="primary"
                    @click="modalWebp = !modalWebp"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.image_webp.click()"
                    v-show="items.image_webp || image_webp"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          </b-form-group>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('image_webp') }}</p>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Image URL JPG"
            label-for="input-1"
          >
            <!-- <input
              v-validate="'required'"
              v-model="items.image_jpg"
              name="title_id"
              data-vv-as="Image URL JPG"
              id="input-1"
              class="form-control"
              placeholder="Image URL JPG"
            /> -->
            <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(580px x 380px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="image_jpg"
                    name="image_jpg"
                    data-vv-as="Image JPG"
                    v-validate="'minimalDimensions:580,380|size:2000|ext:jpg,png,gif,jpeg,svg'"
                    style="display: none"
                    v-on:change="onChangeImageJpg()"
                  />
                  <b-button
                    @click="$refs.image_jpg.click()"
                    v-show="!items.image_jpg && !image_jpg"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_jpg || image_jpg"
                    variant="primary"
                    @click="modalJPG = !modalJPG"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.image_jpg.click()"
                    v-show="items.image_jpg || image_jpg"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          </b-form-group>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('image_jpg') }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Deskripsi Singkat untuk Homepage (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.description.id"
              name="description_id"
              data-vv-as="Deskripsi Singkat untuk Homepage (Bahasa)"
              id="input-1"
              class="form-control"
              placeholder="Deskripsi Singkat untuk Homepage (Bahasa)"
            />
            <b-form-invalid-feedback id="input-description_id-feedback">{{ veeErrors.first('description_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Deskripsi Singkat untuk Homepage (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.description.en"
              name="description_en"
              data-vv-as="Deskripsi Singkat untuk Homepage (English)"
              class="form-control"
              placeholder="Deskripsi Singkat untuk Homepage (English)"
            />
            <b-form-invalid-feedback id="input-description_en-feedback">{{ veeErrors.first('description_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Title (Bahasa)" label-for="input-1">
            <input
              v-validate="'required'"
              v-model="items.title.id"
              name="title_id"
              data-vv-as="Title Bahasa"
              id="input-1"
              class="form-control"
              placeholder="Title In Bahasa Indonesia"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Title (English)" label-for="input-1">
            <input
              v-validate="'required'"
              v-model="items.title.en"
              name="title_en"
              data-vv-as="Title English"
              class="form-control"
              placeholder="Title In English"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Content (Bahasa)" label-for="input-1">
            <ckeditor
              :editor="editor"
              tag-name="textarea"
              placeholder="Content in Bahasa"
              v-model="items.content.id"
              class="form-control"
              data-vv-as="Content Bahasa"
              v-validate="'required'"
              name="content_id"
              :config="editorConfig"
            ></ckeditor>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('content_id') }}</p>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="fieldset-1" label="Content (English)" label-for="input-1">
            <ckeditor
              :editor="editor"
              tag-name="textarea"
              placeholder="Content in English"
              v-model="items.content.en"
              class="form-control"
              v-validate="'required'"
              name="content_en"
              data-vv-as="Content English"
              :config="editorConfig"
            ></ckeditor>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('content_en') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Dengan Tombol"
            label-for="input-1"
          >
            <b-form-radio-group
              id="radio-group-1"
              v-model="items.is_with_button"
              :options="options1"
              name="radio-options"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="items.is_with_button">
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Teks Tombol (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="items.is_with_button ? 'required' : ''"
              v-model="items.button_text.id"
              name="button_text_id"
              data-vv-as="Teks Tombol Bahasa"
              class="form-control"
              placeholder="Teks Tombol Bahasa"
            />
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("button_text_id") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Teks Tombol (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="items.is_with_button ? 'required' : ''"
              v-model="items.button_text.en"
              name="button_text_en"
              data-vv-as="Teks Tombol Bahasa"
              class="form-control"
              placeholder="Teks Tombol Bahasa"
            />
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("button_text_en") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="items.is_with_button">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="URL Tombol"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="
                items.is_with_button
                  ? 'required|url: {require_protocol: true }'
                  : ''
              "
              v-model="items.button_url"
              name="button_url"
              data-vv-as="URL Tombol"
              class="form-control"
              placeholder="URL Tombol"
            />
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("button_url") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Status" label-for="input-1">
            <b-form-radio-group
              id="radio-group-2"
              v-model="items.status"
              :options="options2"
              name="radio-status"
              v-validate="'required'"
              data-vv-as="Status"
            ></b-form-radio-group>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('radio-status') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-right">
        <b-col>
          <b-button variant="primary" :disabled="loading" @click="put()" class="mr-3" size="lg">
            Save
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
          <router-link :to="{name: 'OurService'}">
            <b-button variant="outline-secondary" size="lg">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalIcon" title="Preview Icon" size="xl">
      <img v-show="!icon" v-if="items.icon" width height="400px" :src="items.icon" />
      <img v-show="icon" v-if="urlIcon" width height="400px" :src="urlIcon" />
    </b-modal>
    <b-modal v-model="modalWebp" title="Preview Image" size="xl">
      <img v-show="!image_webp" v-if="items.image_webp" width height="400px" :src="items.image_webp" />
      <img v-show="image_webp" v-if="urlWebp" width height="400px" :src="urlWebp" />
    </b-modal>
    <b-modal v-model="modalJPG" title="Preview Image" size="xl">
      <img v-show="!image_jpg" v-if="items.image_jpg" width height="400px" :src="items.image_jpg" />
      <img v-show="image_jpg" v-if="urlJPG" width height="400px" :src="urlJPG" />
    </b-modal>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mixInCkeditor } from "@/mixin/mixInCkeditor";
export default {
  mixins: [mixInCkeditor],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      loading: false,
      items: [],
      urlIcon: "",
      urlImage: "",
      modalIcon: false,
      modalImage: false,
      image: "",
      icon: "",
      widthImage: null,
      heightImage: null,
      widthIcon: null,
      heightIcon: null,
      InputImage: false,
      InputIcon: false,
      isHiddenEnglish: false,
      isHiddenBahasa: false,
      modalWebp: false,
      modalJPG: false,
      image_webp: "",
      image_jpg: "",
      urlWebp: "",
      urlJPG: "",
      options1: [
        { text: "Tidak", value: false },
        { text: "Ya", value: true },
      ],
      options2: [
        { text: "Publish", value: "publish" },
        { text: "Archive", value: "archive" },
      ],
    };
  },
  beforeCreate() {
    this.$store.dispatch(
      "OurServiceModule/getOurService",
      this.$route.params.id
    );
  },
  created() {
    this.$store.watch(
      state => state.OurServiceModule.our_service_id,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
  },
  methods: {
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Layanan Kami!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              formData.append("title_id", this.items.title.id);
              formData.append("title_en", this.items.title.en);
              formData.append("content_id", this.items.content.id);
              formData.append("content_en", this.items.content.en);
              formData.append("description_id", this.items.description.id);
              formData.append("description_en", this.items.description.en);
              formData.append("icon", this.icon);
              formData.append("image_jpg", this.image_jpg);
              formData.append("image_webp", this.image_webp);
              formData.append("is_with_button", this.items.is_with_button);
              formData.append("button_text_id", this.items.button_text.id);
              formData.append("button_text_en", this.items.button_text.en);
              formData.append("button_url", this.items.button_url);
              formData.append("status", this.items.status);
              this.$store
                .dispatch("OurServiceModule/putOurService", {
                  id: this.$route.params.id,
                  formData
                })
                .then(response => {
                  this.loading = false;
                  this.$router.push({ name: "OurService" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(response);
                })
                .catch(error => {
                  this.loading = false;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  this.serverError = error.response.data;
                  console.log(error);
                });
            } else {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: this.$validator.errors.all(),
                showConfirmButton: false,
                timer: 1500
              });
            }
          });
        }
      });
    },
    onChangeicon() {
      this.icon = this.$refs.icon.files[0];
      const input = this.$refs.icon;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthIcon = img.width;
            this.heightIcon = img.height;
          };
          img.src = e.target.result;
          this.urlIcon = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeImageWebp() {
      this.image_webp = this.$refs.image_webp.files[0];
      const input = this.$refs.image_webp;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlWebp = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeImageJpg() {
      this.image_jpg = this.$refs.image_jpg.files[0];
      const input = this.$refs.image_jpg;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlJPG = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  }
};
</script>

<style>
</style>
